import React from 'react'
import { getSearchUrls, openSearchWindow } from '../../utils/constants'

function SearchLinks({ title }) {
  const urls = getSearchUrls(title)

  return (
    <div className="search-links">
      <button
        onClick={() => openSearchWindow(urls.reverbSold)}
        title="Reverb Sold"
        className="search-link-btn"
      >
        R
      </button>
      <button
        onClick={() => openSearchWindow(urls.ebaySold)}
        title="eBay Sold"
        className="search-link-btn"
      >
        eS
      </button>
      <button
        onClick={() => openSearchWindow(urls.ebayActive)}
        title="eBay Active"
        className="search-link-btn"
      >
        eA
      </button>
      <button
        onClick={() => openSearchWindow(urls.google)}
        title="Google"
        className="search-link-btn"
      >
        G
      </button>
    </div>
  )
}

export default SearchLinks
